import { EffectCallback, useEffect, useRef } from 'react';

export function useDidMount(callback: EffectCallback) {
    const runStatus = useRef(true);

    // Disabled due to useEffect hooks nature
    // eslint-disable-next-line consistent-return
    useEffect(() => {
        if (runStatus.current) {
            return callback();
        }
        // Disabled because we are interested in a single execution
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
